import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"

import ptBR from "@/locales/pt-BR.json"
import en from "@/locales/en.json"

/** Normalizes detector / profile values to supported app locales (`en` | `pt-BR`). */
export function resolveAppLanguage(detected: string): string {
  const lower = detected.toLowerCase()
  if (lower === "pt-br" || lower === "pt" || lower.startsWith("pt-")) return "pt-BR"
  return "en"
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      "pt-BR": { translation: ptBR },
      en: { translation: en },
    },
    fallbackLng: "en",
    supportedLngs: ["pt-BR", "en"],
    detection: {
      order: ["navigator", "localStorage"],
      lookupLocalStorage: "wundrlst_language",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
    load: "currentOnly",
  })

const detected = i18n.language
void i18n.changeLanguage(resolveAppLanguage(detected))

export { i18n }
export default i18n
